import { render, staticRenderFns } from "./MaskToolInfo.vue?vue&type=template&id=1f509470&scoped=true&"
import script from "./MaskToolInfo.vue?vue&type=script&lang=js&"
export * from "./MaskToolInfo.vue?vue&type=script&lang=js&"
import style0 from "./MaskToolInfo.vue?vue&type=style&index=0&id=1f509470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f509470",
  null
  
)

export default component.exports